import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import ListUI from '@material-ui/core/List'

const style = theme => ({
	root: {
		border: `1px solid ${theme.palette.divider}`,
		height: '100%',
		"overflow-y": 'auto',
    	'box-sizing': 'border-box',
    	'max-height': '360px',
	}
})

function List({
	classes,
	ItemComponent,
	items,
	itemProps,
}) {
	return (
		<ListUI
			dense
			className={classes.root}
			disablePadding
		>
			{items.map( (item, i) => {
				return (
					<ItemComponent
						key={i}
						index={i}
						item={item}
						{...itemProps}
					/>
				)
			})}
		</ListUI>
	)
}

List.propTypes = {
	classes: PropTypes.any,
	ItemComponent: PropTypes.object,
	items: PropTypes.array,
}

List.defaultProps = {
	items: [],
}

export default withStyles(style)(List);